import { useEffect, useRef } from "react";

const useOuterClick = (
  callback: (e: MouseEvent) => void,
  conditionToRun: boolean = true
): React.RefObject<HTMLDivElement | null> => {
  const innerRef = useRef<HTMLDivElement>(null);
  const callbackRef = useRef<((e: MouseEvent) => void) | null>(null);

  // set current callback in ref, before second useEffect uses it
  useEffect(() => {
    // useEffect wrapper to be safe for concurrent mode
    callbackRef.current = callback;
  });

  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);

    // read most recent callback and innerRef dom node from refs
    function handleClick(e: MouseEvent) {
      if (
        conditionToRun &&
        innerRef.current &&
        callbackRef.current &&
        !innerRef.current.contains(e.target as Node)
      ) {
        callbackRef.current(e);
      }
    }
  }, [conditionToRun]); // no need for callback + innerRef dep

  return innerRef; // return ref; client can omit `useRef`
};

export default useOuterClick;
